import { GiphyFetch } from '@giphy/js-fetch-api'

export const giphyAPIKey = 'ObF6qeB83P74ddNEtzwgTZSqUKhSV1dc'

export const giphy = new GiphyFetch(giphyAPIKey)
